import { Card, CardContent } from "@/components/ui/card";
import { useRouter } from "@tanstack/react-router";
import { ChevronRight } from "lucide-react";
import { Plus } from "lucide-react";
import { v4 as uuidv4 } from "uuid";
import { ui } from "../../../components/ui";

function TemplateCard() {
	const router = useRouter();

	return (
		<Card
			onClick={() =>
				router.navigate({
					to: "/new/diary/$templateId/organisation",
					params: {
						templateId: uuidv4(),
					},
				})
			}
			className="group relative bg-slate-50 hover:shadow-lg border-2 border-slate-200 hover:border-slate-300 border-dashed h-[480px] overflow-hidden transition-all duration-300 cursor-pointer"
		>
			<CardContent className="p-0">
				<div className="flex flex-col h-full">
					<div className="p-6">
						<h3 className="mb-3 font-bold text-2xl">Add New Template</h3>
						<p className="text-slate-500 text-sm">
							Generate templates for common injections scenarios such as for
							each clinic or for each colleague you work with.
						</p>
					</div>

					<div className="flex flex-1 justify-center items-center p-8">
						<div className="flex justify-center items-center bg-white border-2 border-slate-300 group-hover:border-indigo-300 border-dashed rounded-full w-24 h-24 transition-colors">
							<Plus className="w-10 h-10 text-slate-400 group-hover:text-indigo-500 transition-colors" />
						</div>
					</div>

					<div className="mt-auto">
						<ui.Button
							variant="ghost"
							className="flex justify-center items-center gap-2 hover:bg-indigo-50 group-hover:bg-indigo-100/50 py-6 rounded-none w-full text-indigo-600 hover:text-indigo-700 transition-colors"
						>
							Create Template
							<ChevronRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
						</ui.Button>
					</div>
				</div>
			</CardContent>
		</Card>
	);
}

export default TemplateCard;
